 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"avalon-themeWrapLive":"avalon-themeWrapLive","baronbet-themeWrapLive":"baronbet-themeWrapLive","bb-themeWrapLive":"bb-themeWrapLive","betcoinsportsxmb-themeWrapLive":"betcoinsportsxmb-themeWrapLive","betfirst-themeWrapLive":"betfirst-themeWrapLive","betflip-themeWrapLive":"betflip-themeWrapLive","bethappy-themeWrapLive":"bethappy-themeWrapLive","betmen-themeWrapLive":"betmen-themeWrapLive","betmor-themeWrapLive":"betmor-themeWrapLive","betnest-themeWrapLive":"betnest-themeWrapLive","betsportnamibia-themeWrapLive":"betsportnamibia-themeWrapLive","blackjackfun-themeWrapLive":"blackjackfun-themeWrapLive","bmk-themeWrapLive":"bmk-themeWrapLive","boulparyaj-themeWrapLive":"boulparyaj-themeWrapLive","bugbet-themeWrapLive":"bugbet-themeWrapLive","carrus-themeWrapLive":"carrus-themeWrapLive","liveComponent":"liveComponent","coinhero-themeWrapLive":"coinhero-themeWrapLive","cryptocasino-themeWrapLive":"cryptocasino-themeWrapLive","damagi-dark-themeWrapLive":"damagi-dark-themeWrapLive","damagi-light-themeWrapLive":"damagi-light-themeWrapLive","demo-themeWrapLive":"demo-themeWrapLive","drewmanbetting-themeWrapLive":"drewmanbetting-themeWrapLive","expo-themeWrapLive":"expo-themeWrapLive","formulabih-themeWrapLive":"formulabih-themeWrapLive","futurebet-themeWrapLive":"futurebet-themeWrapLive","grandslotbet-themeWrapLive":"grandslotbet-themeWrapLive","greenlotto-themeWrapLive":"greenlotto-themeWrapLive","happySpins-themeWrapLive":"happySpins-themeWrapLive","hemingwaynew-themeWrapLive":"hemingwaynew-themeWrapLive","heycasino-themeWrapLive":"heycasino-themeWrapLive","isiparyaj-themeWrapLive":"isiparyaj-themeWrapLive","lutrijabihlive-themeWrap":"lutrijabihlive-themeWrap","lyracasino-themeWrapLive":"lyracasino-themeWrapLive","maxbet-themeWrapLive":"maxbet-themeWrapLive","moicasino-themeWrapLive":"moicasino-themeWrapLive","olimp-themeWrapLive":"olimp-themeWrapLive","playbetr-themeWrapLive":"playbetr-themeWrapLive","powerbet-themeWrapLive":"powerbet-themeWrapLive","pozeparyaj-themeWrapLive":"pozeparyaj-themeWrapLive","prontobet-themeWrapLive":"prontobet-themeWrapLive","prvafirma-themeWrapLive":"prvafirma-themeWrapLive","pulsebet-themeWrapLive":"pulsebet-themeWrapLive","quickslots-themeWrapLive":"quickslots-themeWrapLive","reisbet-themeWrapLive":"reisbet-themeWrapLive","satibet-themeWrapLive":"satibet-themeWrapLive","sima-themeWrapLive":"sima-themeWrapLive","slotparadise-themeWrapLive":"slotparadise-themeWrapLive","sportnaloterija-themeWrapLive":"sportnaloterija-themeWrapLive","stanleybet-themeWrapLive":"stanleybet-themeWrapLive","themeWrapLive":"themeWrapLive","themeWrapLiveLight":"themeWrapLiveLight","topbet-themeWrap":"topbet-themeWrap","victory-themeWrapLive":"victory-themeWrapLive","wettnet-themeWrapLive":"wettnet-themeWrapLive","yaacasino-themeWrapLive":"yaacasino-themeWrapLive"}[chunkId]||chunkId) + "-legacy." + {"avalon-themeWrapLive":"5ea1d498","baronbet-themeWrapLive":"8050fe2c","bb-themeWrapLive":"a17b6110","betcoinsportsxmb-themeWrapLive":"56748ef7","betfirst-themeWrapLive":"8af99e71","betflip-themeWrapLive":"94dcdfb4","bethappy-themeWrapLive":"4e975bf0","betmen-themeWrapLive":"838077b9","betmor-themeWrapLive":"21896647","betnest-themeWrapLive":"17484c5a","betsportnamibia-themeWrapLive":"47162149","blackjackfun-themeWrapLive":"9cef0cf0","bmk-themeWrapLive":"8194befa","boulparyaj-themeWrapLive":"b667579e","bugbet-themeWrapLive":"7f32bfac","carrus-themeWrapLive":"3ec6c2e0","chunk-4464ae99":"48288b88","chunk-03b9aa56":"f0b0129e","chunk-7b2248dc":"7e8c6aa8","liveComponent":"741539b2","coinhero-themeWrapLive":"2d3f11ed","cryptocasino-themeWrapLive":"a25ad444","damagi-dark-themeWrapLive":"92456363","damagi-light-themeWrapLive":"6d102686","demo-themeWrapLive":"b8f57897","drewmanbetting-themeWrapLive":"0530a6ee","expo-themeWrapLive":"8e7b4c31","formulabih-themeWrapLive":"920d4a19","futurebet-themeWrapLive":"682b6fb3","grandslotbet-themeWrapLive":"fbaafadd","greenlotto-themeWrapLive":"4a389133","happySpins-themeWrapLive":"d9991091","hemingwaynew-themeWrapLive":"75f172f8","heycasino-themeWrapLive":"699438e6","isiparyaj-themeWrapLive":"b27a06e8","lutrijabihlive-themeWrap":"1d7b47b3","lyracasino-themeWrapLive":"51d23bdc","maxbet-themeWrapLive":"ed292fa6","moicasino-themeWrapLive":"664989a6","olimp-themeWrapLive":"66ca452f","playbetr-themeWrapLive":"3a6e5b78","powerbet-themeWrapLive":"5d74816c","pozeparyaj-themeWrapLive":"36b469e6","prontobet-themeWrapLive":"526df91a","prvafirma-themeWrapLive":"219b09e5","pulsebet-themeWrapLive":"92a827a4","quickslots-themeWrapLive":"4df3ffb0","reisbet-themeWrapLive":"a2eed35b","satibet-themeWrapLive":"333463b2","sima-themeWrapLive":"8526fe90","slotparadise-themeWrapLive":"947a3905","sportnaloterija-themeWrapLive":"90d11881","stanleybet-themeWrapLive":"7d0c4120","themeWrapLive":"07645fe0","themeWrapLiveLight":"e76a775a","topbet-themeWrap":"409a8206","victory-themeWrapLive":"b2f3c25c","wettnet-themeWrapLive":"6d32cfaf","yaacasino-themeWrapLive":"39cb1051"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"avalon-themeWrapLive":1,"baronbet-themeWrapLive":1,"bb-themeWrapLive":1,"betcoinsportsxmb-themeWrapLive":1,"betfirst-themeWrapLive":1,"betflip-themeWrapLive":1,"bethappy-themeWrapLive":1,"betmen-themeWrapLive":1,"betmor-themeWrapLive":1,"betnest-themeWrapLive":1,"betsportnamibia-themeWrapLive":1,"blackjackfun-themeWrapLive":1,"bmk-themeWrapLive":1,"boulparyaj-themeWrapLive":1,"bugbet-themeWrapLive":1,"carrus-themeWrapLive":1,"liveComponent":1,"coinhero-themeWrapLive":1,"cryptocasino-themeWrapLive":1,"damagi-dark-themeWrapLive":1,"damagi-light-themeWrapLive":1,"demo-themeWrapLive":1,"drewmanbetting-themeWrapLive":1,"expo-themeWrapLive":1,"formulabih-themeWrapLive":1,"futurebet-themeWrapLive":1,"grandslotbet-themeWrapLive":1,"greenlotto-themeWrapLive":1,"happySpins-themeWrapLive":1,"hemingwaynew-themeWrapLive":1,"heycasino-themeWrapLive":1,"isiparyaj-themeWrapLive":1,"lutrijabihlive-themeWrap":1,"lyracasino-themeWrapLive":1,"maxbet-themeWrapLive":1,"moicasino-themeWrapLive":1,"olimp-themeWrapLive":1,"playbetr-themeWrapLive":1,"powerbet-themeWrapLive":1,"pozeparyaj-themeWrapLive":1,"prontobet-themeWrapLive":1,"prvafirma-themeWrapLive":1,"pulsebet-themeWrapLive":1,"quickslots-themeWrapLive":1,"reisbet-themeWrapLive":1,"satibet-themeWrapLive":1,"sima-themeWrapLive":1,"slotparadise-themeWrapLive":1,"sportnaloterija-themeWrapLive":1,"stanleybet-themeWrapLive":1,"themeWrapLive":1,"themeWrapLiveLight":1,"topbet-themeWrap":1,"victory-themeWrapLive":1,"wettnet-themeWrapLive":1,"yaacasino-themeWrapLive":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"avalon-themeWrapLive":"avalon-themeWrapLive","baronbet-themeWrapLive":"baronbet-themeWrapLive","bb-themeWrapLive":"bb-themeWrapLive","betcoinsportsxmb-themeWrapLive":"betcoinsportsxmb-themeWrapLive","betfirst-themeWrapLive":"betfirst-themeWrapLive","betflip-themeWrapLive":"betflip-themeWrapLive","bethappy-themeWrapLive":"bethappy-themeWrapLive","betmen-themeWrapLive":"betmen-themeWrapLive","betmor-themeWrapLive":"betmor-themeWrapLive","betnest-themeWrapLive":"betnest-themeWrapLive","betsportnamibia-themeWrapLive":"betsportnamibia-themeWrapLive","blackjackfun-themeWrapLive":"blackjackfun-themeWrapLive","bmk-themeWrapLive":"bmk-themeWrapLive","boulparyaj-themeWrapLive":"boulparyaj-themeWrapLive","bugbet-themeWrapLive":"bugbet-themeWrapLive","carrus-themeWrapLive":"carrus-themeWrapLive","liveComponent":"liveComponent","coinhero-themeWrapLive":"coinhero-themeWrapLive","cryptocasino-themeWrapLive":"cryptocasino-themeWrapLive","damagi-dark-themeWrapLive":"damagi-dark-themeWrapLive","damagi-light-themeWrapLive":"damagi-light-themeWrapLive","demo-themeWrapLive":"demo-themeWrapLive","drewmanbetting-themeWrapLive":"drewmanbetting-themeWrapLive","expo-themeWrapLive":"expo-themeWrapLive","formulabih-themeWrapLive":"formulabih-themeWrapLive","futurebet-themeWrapLive":"futurebet-themeWrapLive","grandslotbet-themeWrapLive":"grandslotbet-themeWrapLive","greenlotto-themeWrapLive":"greenlotto-themeWrapLive","happySpins-themeWrapLive":"happySpins-themeWrapLive","hemingwaynew-themeWrapLive":"hemingwaynew-themeWrapLive","heycasino-themeWrapLive":"heycasino-themeWrapLive","isiparyaj-themeWrapLive":"isiparyaj-themeWrapLive","lutrijabihlive-themeWrap":"lutrijabihlive-themeWrap","lyracasino-themeWrapLive":"lyracasino-themeWrapLive","maxbet-themeWrapLive":"maxbet-themeWrapLive","moicasino-themeWrapLive":"moicasino-themeWrapLive","olimp-themeWrapLive":"olimp-themeWrapLive","playbetr-themeWrapLive":"playbetr-themeWrapLive","powerbet-themeWrapLive":"powerbet-themeWrapLive","pozeparyaj-themeWrapLive":"pozeparyaj-themeWrapLive","prontobet-themeWrapLive":"prontobet-themeWrapLive","prvafirma-themeWrapLive":"prvafirma-themeWrapLive","pulsebet-themeWrapLive":"pulsebet-themeWrapLive","quickslots-themeWrapLive":"quickslots-themeWrapLive","reisbet-themeWrapLive":"reisbet-themeWrapLive","satibet-themeWrapLive":"satibet-themeWrapLive","sima-themeWrapLive":"sima-themeWrapLive","slotparadise-themeWrapLive":"slotparadise-themeWrapLive","sportnaloterija-themeWrapLive":"sportnaloterija-themeWrapLive","stanleybet-themeWrapLive":"stanleybet-themeWrapLive","themeWrapLive":"themeWrapLive","themeWrapLiveLight":"themeWrapLiveLight","topbet-themeWrap":"topbet-themeWrap","victory-themeWrapLive":"victory-themeWrapLive","wettnet-themeWrapLive":"wettnet-themeWrapLive","yaacasino-themeWrapLive":"yaacasino-themeWrapLive"}[chunkId]||chunkId) + "." + {"avalon-themeWrapLive":"0abf2c7a","baronbet-themeWrapLive":"fbabec9b","bb-themeWrapLive":"0a19a380","betcoinsportsxmb-themeWrapLive":"f7477296","betfirst-themeWrapLive":"ef01d141","betflip-themeWrapLive":"5e6d8fd5","bethappy-themeWrapLive":"9c093e71","betmen-themeWrapLive":"0c034e44","betmor-themeWrapLive":"1b4f0370","betnest-themeWrapLive":"78c7e7bd","betsportnamibia-themeWrapLive":"9ddbc14a","blackjackfun-themeWrapLive":"fa94e56e","bmk-themeWrapLive":"8726153a","boulparyaj-themeWrapLive":"917f34e8","bugbet-themeWrapLive":"39e64045","carrus-themeWrapLive":"04c1fd9b","chunk-4464ae99":"31d6cfe0","chunk-03b9aa56":"31d6cfe0","chunk-7b2248dc":"31d6cfe0","liveComponent":"8c1d4266","coinhero-themeWrapLive":"a1f98117","cryptocasino-themeWrapLive":"3dc5f76c","damagi-dark-themeWrapLive":"677e33d6","damagi-light-themeWrapLive":"39e64045","demo-themeWrapLive":"941a4282","drewmanbetting-themeWrapLive":"5b647813","expo-themeWrapLive":"941a4282","formulabih-themeWrapLive":"d311916d","futurebet-themeWrapLive":"6076a8d2","grandslotbet-themeWrapLive":"b3ebd50a","greenlotto-themeWrapLive":"0b0e2099","happySpins-themeWrapLive":"7c501db7","hemingwaynew-themeWrapLive":"8726153a","heycasino-themeWrapLive":"08fc76ab","isiparyaj-themeWrapLive":"ca81d407","lutrijabihlive-themeWrap":"c31c11a0","lyracasino-themeWrapLive":"2a7bbe2b","maxbet-themeWrapLive":"17786a48","moicasino-themeWrapLive":"c3ce7401","olimp-themeWrapLive":"37d2abdb","playbetr-themeWrapLive":"6fd30207","powerbet-themeWrapLive":"742e2c99","pozeparyaj-themeWrapLive":"aea71917","prontobet-themeWrapLive":"859e2d6b","prvafirma-themeWrapLive":"408dd19a","pulsebet-themeWrapLive":"f26b7786","quickslots-themeWrapLive":"11e36e58","reisbet-themeWrapLive":"486bb0db","satibet-themeWrapLive":"0affbbec","sima-themeWrapLive":"9f038130","slotparadise-themeWrapLive":"a736c43f","sportnaloterija-themeWrapLive":"758969a9","stanleybet-themeWrapLive":"d8b42702","themeWrapLive":"917f34e8","themeWrapLiveLight":"a7e5a9fd","topbet-themeWrap":"76545181","victory-themeWrapLive":"7cbb086a","wettnet-themeWrapLive":"0cd8bc5f","yaacasino-themeWrapLive":"ef566a86"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"vendor-utilities","chunk-common"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
